import React, { useEffect, useState } from "react";
import { connect } from 'react-redux'
import { fetchFirmwareReport, fetchVehiclesByFirmware, fetchVehiclesV3 } from "../../../state/actions/vehicles"
import firmware_columns from "./firmware_columns"
import Page from "@modul-connect/shared/components/atoms/page";
import TableWidget from "@modul-connect/shared/components/molecules/tableWidget";
import moment from "moment"
import { Fragment } from "react";
import { useNavigate } from 'react-router-dom';
import FirmwareCharts from "./firmware_charts";

const FirmwareReport = ({vehicles, firmwares_report, fetchFirmwareReport, fetchVehicles, themes, loading}) => {
  const navigate = useNavigate()

  const vehicles_prepared = vehicles.data ? vehicles.data.map(item => {
    return {
      ...item,
      id: item.mainboxId ?? null,
      vin: item?.vin ?? '-',
      serialId: item?.mainboxId?.split('_')?.pop() ?? null,
      telematicsUnit: item?.telematicsId ? 'yes' : 'no',
      model: item?.brandName ? `${item.brandName} ${item?.modelName ?? ''}` : null,
      order_number: item?.orderNumber,
      created_date: moment(item?.createdAt).calendar()
    }
  }) : []
  const [filter, setFilter] = useState({});
  const clearFilter = () => setFilter({})

   const handleClick = (event, id) => {
    navigate('/reports/general_vehicles/' + id);
   }

  useEffect(() => {
    fetchFirmwareReport({})
  }, [])

  return (
    <Fragment>
      {
        <FirmwareCharts
          loadingStatus={loading.fetchFirmwaresReport}
          firmwares_report={firmwares_report} 
          filter={filter}
          onSelect={setFilter}
          onDeselect={clearFilter}/>
      }

      <Page title={filter.firmware ? 'Vehicles running ' + filter.firmware.toUpperCase() + " " + filter.version : 'All vehicles'}>
        <TableWidget
          loadingStatus={loading.fetchVehicles}
          data={ vehicles_prepared }
          totalItems={ vehicles?.total ?? 0 }
          columns={ firmware_columns }
          onFetchData={ (options) => fetchVehicles({
            rowsPerPage: options.rowsPerPage,
            currentpage: options.currentpage,
            sort: options.sort.replace(/asc|desc/gi, "").trim(),
            direction: options.sortOrder, 
            requireTelematics: false,
            firmwareType: filter.firmware || '',
            firmwareVersion: filter.version || '',
          }) }
          fetchAgainOnChange={ false }
          onClickRow={ handleClick }
          searchStr={ filter }
          themes={ themes }
        />
      </Page>
    </Fragment>
  );
};

const mapStateToProps = ({
  vehicles,
  firmwares_report,
  themes,
  loading
}) => ({
  vehicles,
  firmwares_report,
  themes,
  loading
})

const mapDispatchToProps = dispatch => ({
  fetchFirmwareReport: (options) => dispatch(fetchFirmwareReport(options)),
  fetchVehicles: (options) => dispatch(fetchVehiclesV3(options))
})

export default connect(mapStateToProps, mapDispatchToProps)(FirmwareReport);
